import React from 'react'
import { connect } from 'react-redux'
import { Droppable } from 'react-beautiful-dnd'
import styled from 'styled-components'
import Rule from './rule'
import AddRuleButton from './addRuleButton'
import { getRuleRowDroppableId } from '../../dndIdHandler'

const { Component } = React

const HorizontalFlex = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  width: ${props => props.width};
`

class RuleRow extends Component {
  render () {
    let rules = this.props.rules.map((rule, index) => {
      return (<Rule
        key={rule.id}
        index={index}
        rule={rule} />)
    })

    const droppableId = getRuleRowDroppableId(this.props.ruleRowIndex)

    return (
      <Droppable
        droppableId={droppableId}
        direction='horizontal'
        type='rule'>
        {provided => (
          <HorizontalFlex
            ref={provided.innerRef}
            {...provided.droppableProps}
            width={(this.props.rules.length * 295) + 295}
          >
            {rules}
            {provided.placeholder}
            <AddRuleButton
              exampleMapId={this.props.exampleMapId}
              ruleRowIndex={this.props.ruleRowIndex}
            />
          </HorizontalFlex>
        )}
      </Droppable>
    )
  }
}

const mapStateToProps = function (store, ownProps) {
  return {
    ruleRowDroppableIdPrefix: ownProps.ruleRowDroppableIdPrefix,
    ruleRowIndex: ownProps.ruleRowIndex,
    rules: ownProps.rules
  }
}

const mapDispatchToProps = function (dispatch, ownProps) {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RuleRow)
